module.exports = __webpack_public_path__ + "media/recipes/67-eb42125c.png";